const isNeedQingdaoManifest = ["qdManifest"];

export default [
    {
        path: "/qd_manifest",
        component: () => import("@/views/QingdaoManifest/Draft"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/new",
        component: () => import("@/views/QingdaoManifest/Create"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/edit",
        component: () => import("@/views/QingdaoManifest/Create"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/detail",
        component: () => import("@/views/QingdaoManifest/Create"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/wait",
        component: () => import("@/views/QingdaoManifest/WaitSend"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/already",
        component: () => import("@/views/QingdaoManifest/AlreadySend"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qingdao_sft_send",
        component: () => import("@/views/QingdaoManifest/Qingdao_S"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qingdao_sft_revice",
        component: () => import("@/views/QingdaoManifest/Qingdao_R"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qingdao_sft_notice",
        component: () => import("@/views/QingdaoManifest/Qingdao_N"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qingdao_sft_rsn",
        component: () => import("@/views/QingdaoManifest/Qingdao_RSN"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/counter",
        component: () => import("@/views/QingdaoManifest/CounterDelete"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/dustbin",
        component: () => import("@/views/QingdaoManifest/Dustbin"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/uandd",
        component: () => import("@/views/QingdaoManifest/UpdateDelete"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/guide/agreement",
        component: () => import("@/views/QingdaoManifest/guide/Agreement.vue"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/guide/book",
        component: () => import("@/views/QingdaoManifest/guide/Book.vue"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/guide/delete",
        component: () => import("@/views/QingdaoManifest/guide/Delete.vue"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
    {
        path: "/qd_manifest/guide/business",
        component: () => import("@/views/QingdaoManifest/guide/Business.vue"),
        meta: {
            activeMenu: "/qd_manifest",
            experiences: isNeedQingdaoManifest,
            needCompanyRole: true,
            onlyCompany: true,
        },
    },
];
